import React from 'react';
import styled from 'styled-components';
import { withSize } from 'react-sizeme';
import PilotCompanyLogo from './imageComponents/PilotCompanyLogo';
import linkedIn from '../images/icon-linkedin.png';
import twitter from '../images/icon-twitter.svg';
import facebook from '../images/icon-facebook.png';
import instagram from '../images/icon-instagram.svg';

const FooterStyled = styled.footer`
    width: 100%;
    background-color: #101820;
    border-top: 7px solid #e4e2db;
    display: flex;
    flex-wrap: wrap;
    padding: 54px 48px;
    box-sizing: border-box;
    align-items: center;
    color: #fff;

    @media screen and (max-width: 1448px) {
        flex-direction: column;
        justify-content: center;
    }
    svg {
        width: 150px;
    }

    .legal {
        font-family: roboto;
        color: #e5e2d8;
        font-size: 12px;
        display: flex;
        align-items: center;
        list-style-type: none;

        li {
            padding-left: 5px;

            @media screen and (min-width: 1448px) {
                padding-left: 10px;
            }
        }

        @media screen and (max-width: 1448px) {
            padding-top: 10px;
        }

        @media screen and (max-width: 768px) {
            flex-direction: column;
        }
    }

    p.legal {
        margin-left: 48px;
        @media screen and (max-width: 1448px) {
            margin-left: 0px;
        }
    }

    ul.legal a {
        color: #e5e2d8;
        text-decoration: underline;
        margin-left: 4px;

        @media screen and (min-width: 1448px) {
            margin-left: 10px;
        }

        &:hover {
            text-decoration: underline;
        }
    }

    .employee-login {
        font-size: 12px;
        font-style: italic;
        line-height: 14px;
        letter-spacing: 2px;
        margin-right: 21px;
    }

    .social {
        position: absolute;
        list-style-type: none;
        display: flex;
        font-weight: bold;
        align-items: center;
        display: flex;
        flex-direction: column;

        li {
            margin: 4px 0;

            @media screen and (min-width: 768px) {
                margin: 0 10px 0 0;
                
                &:last-child{
                    margin-right: 0;
                }
            }
        }

        @media screen and (min-width: 768px) {
            flex-direction: row;
        }

        @media screen and (min-width: 1448px) {
            right: 24px;
        }

        img {
            width: 20px;
            padding: 8px 4px;
        }

        a {
            color: white;
            text-decoration: none;
        }

        ul {
            display: flex;
            list-style: none;
            li {
                margin-right: 5px;
            }
        }

        @media screen and (max-width: 1448px) {
            padding-top: 10px;
            position: inherit;
            font-size: 12px;

            img {
                padding-right: 8px;
            }
        }
    }
`;

const Footer = ({ size }) => (
    <FooterStyled>
        <PilotCompanyLogo hideCompany={true} isMobile={true}></PilotCompanyLogo>
        <p className="legal">
            © {new Date().getFullYear()} Pilot Travel Centers LLC. All rights reserved.{' '}
        </p>
        <ul className="legal">
            <li>
                {size.width > 1448 ? '•' : null}
                <a
                    href="https://www.pilotflyingj.com/privacy-policy"
                    target="_blank"
                    rel="noreferrer noopener"
                >
                    Privacy Policy{' '}
                </a>
            </li>
            <li>
                {size.width > 550 ? '•' : null}
                <a
                    href="https://www.pilotflyingj.com/terms-and-conditions"
                    target="_blank"
                    rel="noreferrer noopener"
                >
                    Terms &amp; Conditions
                </a>
            </li>
            <li>
                {size.width > 550 ? '•' : null}
                <a
                    href="https://privacy.pilotflyingj.com"
                    target="_blank"
                    rel="noreferrer noopener"
                >
                    Do Not Sell or Share My Personal Information
                </a>
            </li>
        </ul>
        <ul className="social">
            <li className="employee-login">
                <a href="https://pilotco.pilotcompany.com/s/">TEAM MEMBER LOGIN</a>
            </li>
            {size.width > 768 ? <li>{'•'}</li> : null}
            <li className="employee-login">
                <a href="https://edocs.pilotcompany.com/Auth/Login">
                    FORMER TEAM MEMBER DOCS
                </a>
            </li>
            <li>
                <ul>
                    <li>
                        <a
                            href="https://www.facebook.com/thepilotco"
                            target="_blank"
                            rel="noreferrer noopener"
                        >
                            <img src={facebook} alt="facebook" />
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://www.instagram.com/thepilotco/"
                            target="_blank"
                            rel="noreferrer noopener"
                        >
                            <img src={instagram} alt="Pilot Company's Instagram" />
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://www.linkedin.com/company/64553443/"
                            target="_blank"
                            rel="noreferrer noopener"
                        >
                            <img src={linkedIn} alt="linked in" />
                        </a>
                    </li>
                </ul>
            </li>
        </ul>
    </FooterStyled>
);

export default withSize()(Footer);
